export function getRandomValue<T>(arr: [T, ...T[]]): T {
	const randomIndex = Math.floor(Math.random() * arr.length);
	return arr[randomIndex];
}

export const randomUuid = () => {
	return crypto.randomUUID();
};

export const randomBoolean = () => {
	return getRandomValue([true, false]);
};
